import { authPost } from "@api";

import { RunBody, RunResponse, Snippet } from "@pages/editor/types";

const RUN_URL = `/api/run`;

export const run = (
  snippet: Snippet,
  yaml: boolean,
  options: {
    is_develop?: boolean;
    is_deep?: boolean;
  }
): Promise<RunResponse> => {
  return authPost<RunBody, RunResponse>(RUN_URL, {
    ...snippet,
    yaml,
    ...options,
  });
};
